import React, { useState } from 'react';
import { connect } from 'react-redux';

import { fetchPatients } from '../../../../../actions/patientsActions';
import { syncBot, updateCity } from '../../../../../actions';
import DoctorsPageList from '../../../../listv2/doctorsPageList';

import {
  doctorScheduleDateRangeResize,
  getDoctors,
  getDoctorsByDaysSchedule,
  getDoctorSchedule,
  getDoctorsJobs,
  setCalendarDate,
} from '../../../../../actions/doctors';
import useDoctorScheduleDateRangeResize from '../../../../../hooks/useDoctorScheduleDateRangeResize';

const DoctorsList = ({
  doctor,
  doctors,
  doctorSchedule,
  doctorsByDaysSchedule,
  getDoctors,
  getDoctorSchedule,
  getDoctorsByDaysSchedule,
  getDoctorsJobs,
  doctorsJobs,
  getPatients,
  user,
  syncBot,
  currentDoctorsOrderBy,
  setCalendarDate,
  currentDivisionId,
  placeholder,
  isOperator = false,
  websiteCovidSource = null,
  patients,
}) => {
  useDoctorScheduleDateRangeResize({ datesRange: doctorSchedule?.datesRange, doctorScheduleDateRangeResize });
  
  const [searchFilters, setSearchFilters] = useState({});

  return (
    <DoctorsPageList
      websiteCovidSource={websiteCovidSource}
      isOperator={isOperator}
      currentDivisionId={currentDivisionId}
      doctor={doctor}
      doctors={doctors}
      doctorSchedule={doctorSchedule}
      doctorsByDaysSchedule={doctorsByDaysSchedule}
      getDoctorsJobs={getDoctorsJobs}
      doctorsJobs={doctorsJobs}
      getPatients={getPatients}
      user={user}
      city={user.city}
      syncBot={syncBot}
      currentDoctorsOrderBy={currentDoctorsOrderBy}
      setCalendarDate={setCalendarDate}
      placeholder={placeholder}
      patients={patients}
      searchFilters={searchFilters}
      setSearchFilters={setSearchFilters}
      disableOwnLink
      isVaccinates
    />
  );
};

const mapStateToProps = ({ doctor, doctors, doctorSchedule, doctorsByDaysSchedule, doctorsJobs, user, patients }) => ({
  doctor,
  doctors,
  doctorSchedule,
  user,
  doctorsByDaysSchedule,
  doctorsJobs,
  patients,
});

const mapDispatchToProps = {
  getDoctors,
  getDoctorSchedule,
  getDoctorsByDaysSchedule,
  getDoctorsJobs,
  setCalendarDate,
  getPatients: fetchPatients,
  syncBot,
  updateCity,
  doctorScheduleDateRangeResize,
};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorsList);
